import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { AVideoAspectRatio } from '../../atoms/AVideo/AVideo.types';

const getAspectValue = (ratio?: AVideoAspectRatio): string => (ratio ? ratio.replace(':', ' / ') : '16 / 9');

export const Wrapper = styled.button<{ $hasError: boolean; $aspectRatio?: AVideoAspectRatio; $noImage?: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) => getAspectValue($aspectRatio)};
  overflow: hidden;
  border-radius: 0;
  background-color: ${({ $noImage }) =>
    $noImage ? 'var(--t-error-overlay-bg, #000000)' : `var(--t-brand-bg-color, ${baseVariables.color.base10})`};
  transition: all 0.1s ease;
  border: none;
  padding: 0;
  margin: 0;
  display: block;

  @media ${baseVariables.mediaQuery.md} {
    border-radius: var(--t-images-border-radius);
  }

  &:active {
    transform: ${({ $hasError }) => ($hasError ? 'none' : 'scale(0.98)')};
  }

  picture,
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const ThumbnailImage = styled.div`
  position: absolute;
  inset: 0;

  picture {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

export const VideoContainer = styled.div`
  position: absolute;
  inset: 0;

  > * {
    width: 100%;
    height: 100%;
  }

  .video-js {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    padding-top: 0;
  }

  video {
    object-fit: cover;
  }
`;

export const OverlayContainer = styled.div`
  position: absolute;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  --t-color-control-background-overlay: rgba(255, 255, 255, 0.54);

  > * {
    pointer-events: auto;
  }
`;

export const ErrorOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--t-error-overlay-bg, #000000);
  color: var(--t-error-overlay-text, #ffffff);
  z-index: 2;
`;

export const ImageErrorOverlay = styled(ErrorOverlay)`
  flex-direction: column;
  justify-content: center;
  padding-block-end: 15%;
  gap: ${baseVariables.spacers?.spacers?.[2] ?? '0.5rem'};
`;

export const ErrorText = styled.p`
  color: inherit;
  font: normal normal 400 var(--t-font-s-font-size-viewport-xs, 0.875rem) /
    var(--t-font-s-line-height-viewport-xs, 1.25rem) var(--t-base-font-family);
  text-align: center;
  margin: 0;
  padding: ${baseVariables.spacers?.spacers?.[3] ?? '1rem'};
  word-break: break-word;
`;
